/***
 * Summary: here resides the scheme and roles for the fields of the network performing
 * 
 */
import { yupToFormErrors } from "formik";
import * as Yup from "yup";

const TODIS_LRAIL_SCHEMA = Yup.object().shape({
    //general section Rules:
    startKm: Yup.number()
        .typeError("Invalid data. 'Start km' must be a 'number'")
        .nullable(true)
        .test('is-number', 'Invalid data. \'Start km\' must be a number', function (value) {
            if (value === null && value === undefined && (isNaN(value) || value !== 0)) {
                throw this.createError({ message: 'Invalid data. \'Start km\' must be a number' });
            }
            return true;
        }),
    endKm: Yup.number()
        .typeError("Invalid data. 'End km' must be a 'number'")
        .nullable(true)
        .test('is-number', 'Invalid data. \'End km\' must be a number', function (value) {
            if (value === null && value === undefined && (isNaN(value) || value !== 0)) {
                throw this.createError({ message: 'Invalid data. \'End km\' must be a number' });
            }
            return true;
        }),
    dateValidTo: Yup.date("Valid from is a Date").required().nullable(true),
    dateValidFrom: Yup.date("Valid to is a Date").required().nullable(true),
    dateValidFor: Yup.string("Valid for is a Year").nullable(true),
    tentTCategory: Yup.string("tent category is alphanumeric").nullable(true),
    routeId: Yup.string("Route ID is alphanumeric").nullable(true),
    nationalRouteId: Yup.string("National Route ID is alphanumeric").nullable(true),
    internatRouteId: Yup.string("International Route ID is alphanumeric").nullable(true),
    startNodeName: Yup.string("Start Node Name ID is alphanumeric").nullable(true),
    endNodeName: Yup.string("End Node Name is alphanumeric").nullable(true),
    nameResp: Yup.string("Road ID is alphanumeric").nullable(true),
    addressResp: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPer: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPos: Yup.string("Road ID is alphanumeric").nullable(true),
    contactNum: Yup.string()
        .transform((originalValue) => {
            // Si el valor comienza con '+', eliminamos ese símbolo
            return typeof originalValue === 'string' ? originalValue.replace(/^\+/, '') : originalValue;
        })
        .nullable(true)
        .test('is-valid', 'Invalid data. \'Phone Number\' must be a valid number', function (value) {
            // Permitir números, espacios, y la presencia de '+'
            const isValid = /^[0-9+\s]+$/.test(value) || value === null;

            if (!isValid) {
                throw this.createError({ message: 'Invalid data. \'Phone Number\' must be a valid number' });
            }

            return true;
        }),

    contactEmail: Yup.string("Email")
        .transform((originalValue) => {
            // Realizar transformaciones si es necesario
            return typeof originalValue === 'string' ? originalValue.trim() : originalValue;
        })
        .nullable(true)
        .test('is-email', 'Invalid data. \'Email\' must be valid', function (value) {
            // Si el valor es null o undefined, lo consideramos válido y no aplicamos más validaciones
            if (value === null || value === undefined) {
                return true;
            }

            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

            // Verificar si es una cadena antes de intentar dividirla
            if (typeof value === 'string') {
                const emails = value.split(/[,;:]+/);  // Separar por comas, punto y coma, o dos puntos

                for (const email of emails) {
                    if (!emailRegex.test(email.trim())) {
                        throw this.createError({ message: `Invalid data. '${email}' must be a valid email address` });
                    }
                }
            }

            return true;
        }),

    countryCode: Yup.string("Country Code").nullable(true),
    startKmDirA: Yup.number()
        .typeError("Invalid data. 'Start km (Direction A)' must be a 'number'")
        .nullable(true)
        .test('is-number', 'Invalid data. \'Start km (Direction A)\' must be a number', function (value) {
            if (value === null && value === undefined && (isNaN(value) || value !== 0)) {
                throw this.createError({ message: 'Invalid data. \'Start km (Direction A)\' must be a number' });
            }
            return true;
        }),
    startKmDirB: Yup.number()
        .typeError("Invalid data. 'Start km (Direction B)' must be a 'number'")
        .nullable(true)
        .test('is-number', 'Invalid data. \'Start km (Direction B)\' must be a number', function (value) {
            if (value === null && value === undefined && (isNaN(value) || value !== 0)) {
                throw this.createError({ message: 'Invalid data. \'Start km (Direction B)\' must be a number' });
            }
            return true;
        }),
    endKmDirA: Yup.number()
        .typeError("Invalid data. 'End km (Direction A)' must be a 'number'")
        .nullable(true)
        .test('is-number', 'Invalid data. \'End km (Direction A)\' must be a number', function (value) {
            if (value === null && value === undefined && (isNaN(value) || value !== 0)) {
                throw this.createError({ message: 'Invalid data. \'End km (Direction A)\' must be a number' });
            }
            return true;
        }),
    endKmDirB: Yup.number()
        .typeError("Invalid data. 'End km (Direction B)' must be a 'number'")
        .nullable(true)
        .test('is-number', 'Invalid data. \'End km (Direction B)\' must be a number', function (value) {
            if (value === null && value === undefined && (isNaN(value) || value !== 0)) {
                throw this.createError({ message: 'Invalid data. \'End km (Direction B)\' must be a number' });
            }
            return true;
        }),
    remarks: Yup.string("remarks").nullable(true),
    railwaysLivePmDescDTO: Yup.object().shape({
        projectName: Yup.string('Value should be a text').nullable(true),
        typeForeseenInterven: Yup.string('Value should be a text').nullable(true),
        length: Yup.string('Value should be a text').nullable(true),
        totalCostCapex: Yup.number()
            .typeError("Invalid data. 'Total Cost (CAPEX) (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Total Cost (CAPEX) (Euro)\' must be a number', function (value) {
                if (value === null && value === undefined && (isNaN(value) || value !== 0)) {
                    throw this.createError({ message: 'Invalid data. \'Total Cost (CAPEX) (Euro)\' must be a number' });
                }
                return true;
            }),
        estiImpDeadline: Yup.date("Valid from is a Date").nullable(true),
        remarks: Yup.string("remarks").nullable(true)
    }),
    railwaysLivePmEligiTentDTO: Yup.object().shape({
        electrification: Yup.string().nullable(true),
        lineSpeed100KmFreight: Yup.string().nullable(true),
        axleLoad225T: Yup.string().nullable(true),
        trackGouge: Yup.string().nullable(true),
        trainLength740M: Yup.string().nullable(true),
        ertmsDeployEtcs: Yup.string().nullable(true),
        ertmsDeployGsmr: Yup.string().nullable(true),
        remarks: Yup.string("remarks").nullable(true),
        passengerDesignSpeed160: Yup.string().nullable(true),
        loadingGauge: Yup.string().nullable(true),
        maxDwellingTimeCrossBorder25: Yup.string().nullable(true),
        strongInclines: Yup.string().nullable(true)
    }),
    railwaysLivePmIndicatorsDTO: Yup.object().shape({
        siAnnTraffDemGro: Yup.number()
            .typeError("Invalid data. 'Annual traffic demand growth (%)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Annual traffic demand growth (%)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Annual traffic demand growth (%)\' must be a number' });
                }
                return true;
            }),
        siModalTrans: Yup.number()
            .typeError("Invalid data. 'Modal transfer - if applicable (%)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Modal transfer - if applicable (%)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Modal transfer - if applicable (%)\' must be a number' });
                }
                return true;
            }),
        siAnnTraffAcciRateRed: Yup.number()
            .typeError("Invalid data. 'Annual accident rate reduction - if applicable (%)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Annual accident rate reduction - if applicable (%)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Annual accident rate reduction - if applicable (%)\' must be a number' });
                }
                return true;
            }),
        eiEirr: Yup.number()
            .typeError("Invalid data. 'Economic internal rate of return (%)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Economic internal rate of return (%)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Economic internal rate of return (%)\' must be a number' });
                }
                return true;
            }),
        eiNpv: Yup.number()
            .typeError("Invalid data. 'Net present value (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Net present value (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Net present value (Euro)\' must be a number' });
                }
                return true;
            }),
        eiSdr: Yup.number()
            .typeError("Invalid data. 'Social discount rate (%)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Social discount rate (%)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Social discount rate (%)\' must be a number' });
                }
                return true;
            }),
        eiProjPlanDesCost: Yup.number()
            .typeError("Invalid data. 'Project planning & design cost (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Project planning & design cost (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Project planning & design cost (Euro)\' must be a number' });
                }
                return true;
            }),
        eiProjConstCost: Yup.number()
            .typeError("Invalid data. 'Project construction cost (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Project construction cost (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Project construction cost (Euro)\' must be a number' });
                }
                return true;
            }),
        eiTotalProjCost: Yup.number()
            .typeError("Invalid data. 'Total project cost (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Total project cost (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Total project cost (Euro)\' must be a number' });
                }
                return true;
            }),
        fiFirr: Yup.number()
            .typeError("Invalid data. 'FIRR (Financial Internal Rate of Return)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'FIRR (Financial Internal Rate of Return)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'FIRR (Financial Internal Rate of Return)\' must be a number' });
                }
                return true;
            }),
        fiFnpv: Yup.number()
            .typeError("Invalid data. 'Financial net present value (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Financial net present value (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Financial net present value (Euro)\' must be a number' });
                }
                return true;
            }),
        fiFdr: Yup.number()
            .typeError("Invalid data. 'Financial discount rate (%)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Financial discount rate (%)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Financial discount rate (%)\' must be a number' });
                }
                return true;
            }),
        fiWacc: Yup.number()
            .typeError("Invalid data. 'Weighted average cost of capital (%)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Weighted average cost of capital (%)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Weighted average cost of capital (%)\' must be a number' });
                }
                return true;
            }),
        fiFirtsYearProf: Yup.date("Valid from is a Date").nullable(true),
        fiDscr: Yup.number()
            .typeError("Invalid data. 'Debt service coverage ratio (%)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Debt service coverage ratio (%)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Debt service coverage ratio (%)\' must be a number' });
                }
                return true;
            }),
        eniCo2Ems: Yup.number()
            .typeError("Invalid data. 'CO2 emissions (+/- %)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'CO2 emissions (+/- %)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'CO2 emissions (+/- %)\' must be a number' });
                }
                return true;
            }),
        eniNoxEms: Yup.number()
            .typeError("Invalid data. 'Nox emissions (+/- %)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Nox emissions (+/- %)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Nox emissions (+/- %)\' must be a number' });
                }
                return true;
            }),
        eniSo2Ems: Yup.number()
            .typeError("Invalid data. 'SO2 emissions (+/- %)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'SO2 emissions (+/- %)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'SO2 emissions (+/- %)\' must be a number' });
                }
                return true;
            }),
        eniNmhcEms: Yup.number()
            .typeError("Invalid data. 'Non-methane hydrocarbons (+/- %)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Non-methane hydrocarbons (+/- %)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Non-methane hydrocarbons (+/- %)\' must be a number' });
                }
                return true;
            }),
        eniPpm: Yup.number()
            .typeError("Invalid data. 'Particulate matter – ppm (+/- %)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Particulate matter – ppm (+/- %)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Particulate matter – ppm (+/- %)\' must be a number' });
                }
                return true;
            }),
        eniNoiseLevel: Yup.number()
            .typeError("Invalid data. 'Noise levels along the section (+/- %)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Noise levels along the section (+/- %)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Noise levels along the section (+/- %)\' must be a number' });
                }
                return true;
            }),
        eniCliChangeRes: Yup.string("tent category is alphanumeric").nullable(true),
        eniProteNatuaAff: Yup.number()
            .typeError("Invalid data. 'Protected natural areas affected (km2)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Protected natural areas affected (km2)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Protected natural areas affected (km2)\' must be a number' });
                }
                return true;
            }),
        remarks: Yup.string("remarks").nullable(true),
    }),
    railwaysLivePmPiDTO: Yup.object().shape({
        forecastConstPeriod: Yup.number('Value should be number').nullable(true),
        actualConstPeriod: Yup.number('Value should be number').nullable(true),
        forecastCapex: Yup.number('Value should be number').nullable(true),
        actualCapex: Yup.number('Value should be number').nullable(true),
        forecastOpex: Yup.number('Value should be number').nullable(true),
        actualOpex: Yup.number('Value should be number').nullable(true),
        forecastMaintCost: Yup.number('Value should be number').nullable(true),
        actualMaintCost: Yup.number('Value should be number').nullable(true),
        interestDuringConst: Yup.string('Value should be a text').nullable(true),
        ebitda: Yup.string('Value should be a text').nullable(true),
        forecastRevenue: Yup.number('Value should be number').nullable(true),
        actualRevenue: Yup.number('Value should be number').nullable(true),
        forecastTrainTraffic: Yup.string('Value should be a text').nullable(true),
        actualTrainTraffic: Yup.string('Value should be a text').nullable(true),
        forecastPassTraffic: Yup.string('Value should be a text').nullable(true),
        actualPassTraffic: Yup.string('Value should be a text').nullable(true),
        forecastFreightTn: Yup.string('Value should be a text').nullable(true),
        actualFreightTn: Yup.string('Value should be a text').nullable(true),
        remarks: Yup.string("remarks").nullable(true)
    }),
    railwaysLivePmStatusDTO: Yup.object().shape({
        implemented: Yup.string('Value should be a text').nullable(true),
        ongoingProjFs: Yup.string('Value should be a text').nullable(true),
        matureProjFs: Yup.string('Value should be a text').nullable(true),
        projUnderPrep: Yup.string('Value should be a text').nullable(true),
        projStatusDesc: Yup.string('Value should be a text').nullable(true),
        projFundNatBudg: Yup.number()
            .typeError("Invalid data. 'National Budget (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'National Budget (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'National Budget (Euro)\' must be a number' });
                }
                return true;
            }),
        projFundNatBudgAllo: Yup.boolean().nullable(true),
        projFundWb: Yup.number()
            .typeError("Invalid data. 'World Bank (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'World Bank (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'World Bank (Euro)\' must be a number' });
                }
                return true;
            }),
        projFundWbAllo: Yup.boolean().nullable(true),
        projFundEbrd: Yup.number()
            .typeError("Invalid data. 'EBRD (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'EBRD (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'EBRD (Euro)\' must be a number' });
                }
                return true;
            }),
        projFundEbrdAllo: Yup.boolean().nullable(true),
        projFundEib: Yup.number()
            .typeError("Invalid data. 'EIB (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'EIB (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'EIB (Euro)\' must be a number' });
                }
                return true;
            }),
        projFundEibAllo: Yup.boolean().nullable(true),
        otherIfi: Yup.number()
            .typeError("Invalid data. 'Other IFI (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Other IFI (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Other IFI (Euro)\' must be a number' });
                }
                return true;
            }),
        otherIfiSpec: Yup.string('Value should be a text').nullable(true),
        otherIfiAllo: Yup.boolean().nullable(true),
        concession: Yup.number()
            .typeError("Invalid data. 'Concessions (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Concessions (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Concessions (Euro)\' must be a number' });
                }
                return true;
            }),
        concessionSpec: Yup.string('Value should be a text').nullable(true),
        concessionAllo: Yup.boolean().nullable(true),
        euFund: Yup.number()
            .typeError("Invalid data. 'EU Fund (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'EU Fund (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'EU Fund (Euro)\' must be a number' });
                }
                return true;
            }),
        euFundSpec: Yup.string('Value should be a text').nullable(true),
        euFundAllo: Yup.boolean().nullable(true),
        otherFund: Yup.number()
            .typeError("Invalid data. 'Other funding source (name)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Other funding source (name)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Other funding source (name)\' must be a number' });
                }
                return true;
            }),
        otherFundSpec: Yup.string('Value should be a text').nullable(true),
        otherFundAllo: Yup.boolean().nullable(true),
        preFeasiStudy: Yup.boolean().nullable(true),
        feasiStudy: Yup.boolean().nullable(true),
        conceptDesign: Yup.boolean().nullable(true),
        prelimDesign: Yup.boolean().nullable(true),
        detailDesign: Yup.boolean().nullable(true),
        environImpactAssess: Yup.boolean().nullable(true),
        projFeasiStudyTitley: Yup.string('Value should be a text').nullable(true),
        projFeasiStudyPrepBy: Yup.string('Value should be a text').nullable(true),
        projFeasiStudySupervBy: Yup.string('Value should be a text').nullable(true),
        conceptDesignTitle: Yup.string('Value should be a text').nullable(true),
        conceptDesignPrepBy: Yup.string('Value should be a text').nullable(true),
        conceptDesignSupervBy: Yup.string('Value should be a text').nullable(true),
        prelimDesignTitle: Yup.string('Value should be a text').nullable(true),
        prelimDesignPrepBy: Yup.string('Value should be a text').nullable(true),
        prelimDesignSupervBy: Yup.string('Value should be a text').nullable(true),
        detailDesignTitle: Yup.string('Value should be a text').nullable(true),
        detailDesignPrepBy: Yup.string('Value should be a text').nullable(true),
        detailDesignSupervBy: Yup.string('Value should be a text').nullable(true),
        environImpactAssessTitle: Yup.string('Value should be a text').nullable(true),
        environImpactAssessPrepBy: Yup.string('Value should be a text').nullable(true),
        environImpactAssessSupervBy: Yup.string('Value should be a text').nullable(true),
        tenderStartDateInitFore: Yup.date("Valid to is a Date").nullable(true),
        tenderStartDateCurrEst: Yup.date("Valid to is a Date").nullable(true),
        tenderStartDateActual: Yup.date("Valid to is a Date").nullable(true),
        designCompDateFore: Yup.date("Valid to is a Date").nullable(true),
        designCompDateCurrEst: Yup.date("Valid to is a Date").nullable(true),
        designCompDateActual: Yup.date("Valid to is a Date").nullable(true),
        projCompDateFore: Yup.date("Valid to is a Date").nullable(true),
        projCompDateCurrEst: Yup.date("Valid to is a Date").nullable(true),
        remarks: Yup.string("remarks").nullable(true),
    }),
    railwaysLivePmTentcompDTO: Yup.object().shape({
        electrificationBefProj: Yup.string().nullable(true),
        electrificationAftProjImp: Yup.string().nullable(true),
        befLineSpeed100Km: Yup.string().nullable(true),
        aftLineSpeed100Km: Yup.string().nullable(true),
        befAxleLoad225T: Yup.string().nullable(true),
        aftAxleLoad225T: Yup.string().nullable(true),
        befTrackGauge: Yup.string().nullable(true),
        aftTrackGauge: Yup.string().nullable(true),
        befTrainLength740M: Yup.string().nullable(true),
        aftTrainLength740M: Yup.string().nullable(true),
        befErtmsDeployEtcs: Yup.string().nullable(true),
        aftErtmsDeployEtcs: Yup.string().nullable(true),
        befErtmsDeployGsmr: Yup.string().nullable(true),
        aftErtmsDeployGsmr: Yup.string().nullable(true),
        remarks: Yup.string("remarks").nullable(true),
        befPassengerDesignSpeed160: Yup.string().nullable(true),
        aftPassengerDesignSpeed160: Yup.string().nullable(true),
        befLoadingGauge: Yup.string().nullable(true),
        aftLoadingGauge: Yup.string().nullable(true),
        befMaxDwellingTimeCrossBorder25: Yup.string().nullable(true),
        aftMaxDwellingTimeCrossBorder25: Yup.string().nullable(true),
        befStrongInclines: Yup.string().nullable(true),
        aftStrongInclines: Yup.string().nullable(true)
    }),
});




const LRAIL_INIT = {
    //general section Rules:
    startKm: "",
    endKm: "",
    dateValidTo: "",
    dateValidFrom: "",
    dateValidFor: "",
    tentTCategory: "",
    routeId: "",
    nationalRouteId: "",
    internatRouteId: "",
    startNodeName: "",
    endNodeName: "",
    general_status: "",
    nameResp: "",
    addressResp: "",
    contactPer: "",
    contactPos: "",
    contactNum: 0,
    contactEmail: "",
    countryCode: "",
    startKmDirA: "",
    startKmDirB: "",
    endKmDirA: "",
    endKmDirB: "",
    targetTentSec: "",
    newTentSec: "",
    immedPartTentNet: false,
    remarks: "",
    railwaysLivePmDescDTO: {
        projectName: "",
        typeForeseenInterven: "",
        length: "",
        totalCostCapex: "",
        estiImpDeadline: "",
        remarks: ""
    },
    railwaysLivePmEligiTentDTO: {
        electrification: false,
        lineSpeed100KmFreight: false,
        axleLoad225T: false,
        trackGouge: false,
        trainLength740M: false,
        ertmsDeployEtcs: false,
        ertmsDeployGsmr: false,
        remarks: "",
        passengerDesignSpeed160: false,
        loadingGauge: false,
        maxDwellingTimeCrossBorder25: false,
        strongInclines: false
    },
    railwaysLivePmIndicatorsDTO: {
        siAnnTraffDemGro: "",
        siModalTrans: "",
        siAnnTraffAcciRateRed: "",
        eiEirr: "",
        eiNpv: "",
        eiSdr: "",
        eiProjPlanDesCost: "",
        eiProjConstCost: "",
        eiTotalProjCost: "",
        fiFirr: "",
        fiFnpv: "",
        fiFdr: "",
        fiWacc: "",
        fiFirtsYearProf: "",
        fiDscr: "",
        eniCo2Ems: "",
        eniNoxEms: "",
        eniSo2Ems: "",
        eniNmhcEms: "",
        eniPpm: "",
        eniNoiseLevel: "",
        eniCliChangeRes: "",
        eniProteNatuaAff: "",
        remarks: ""
    },
    railwaysLivePmPiDTO: {
        forecastConstPeriod: "",
        actualConstPeriod: "",
        forecastCapex: "",
        actualCapex: "",
        forecastOpex: "",
        actualOpex: "",
        forecastMaintCost: "",
        actualMaintCost: "",
        interestDuringConst: "",
        ebitda: "",
        forecastRevenue: "",
        actualRevenue: "",
        forecastTrainTraffic: "",
        actualTrainTraffic: "",
        forecastPassTraffic: "",
        actualPassTraffic: "",
        forecastFreightTn: "",
        actualFreightTn: "",
        remarks: ""
    },
    railwaysLivePmStatusDTO: {
        implemented: "",
        ongoingProjFs: "",
        matureProjFs: "",
        projUnderPrep: "",
        projStatusDesc: "",
        projFundNatBudg: "",
        projFundNatBudgAllo: false,
        projFundWb: "",
        projFundWbAllo: false,
        projFundEbrd: "",
        projFundEbrdAllo: false,
        projFundEib: "",
        projFundEibAllo: false,
        otherIfi: "",
        otherIfiSpec: "",
        otherIfiAllo: false,
        concession: "",
        concessionSpec: "",
        concessionAllo: false,
        euFund: "",
        euFundSpec: "",
        euFundAllo: false,
        otherFund: "",
        otherFundSpec: "",
        otherFundAllo: false,
        preFeasiStudy: "",
        feasiStudy: "",
        conceptDesign: "",
        prelimDesign: "",
        detailDesign: "",
        environImpactAssess: "",
        projFeasiStudyTitle: "",
        projFeasiStudyPrepBy: "",
        projFeasiStudySupervBy: "",
        conceptDesignTitle: "",
        conceptDesignPrepBy: "",
        conceptDesignSupervBy: "",
        prelimDesignTitle: "",
        prelimDesignPrepBy: "",
        prelimDesignSupervBy: "",
        detailDesignTitle: "",
        detailDesignPrepBy: "",
        detailDesignSupervBy: "",
        environImpactAssessTitle: "",
        environImpactAssessPrepBy: "",
        environImpactAssessSupervBy: "",
        tenderStartDateInitFore: "",
        tenderStartDateCurrEst: "",
        tenderStartDateActual: "",
        designCompDateFore: "",
        designCompDateCurrEst: "",
        designCompDateActual: "",
        projCompDateFore: "",
        projCompDateCurrEst: "",
        remarks: ""
    },
    railwaysLivePmTentcompDTO: {
        electrificationBefProj: false,
        electrificationAftProjImp: false,
        befLineSpeed100Km: false,
        aftLineSpeed100Km: false,
        befAxleLoad225T: false,
        aftAxleLoad225T: false,
        befTrackGauge: false,
        aftTrackGauge: false,
        befTrainLength740M: false,
        aftTrainLength740M: false,
        befErtmsDeployEtcs: false,
        aftErtmsDeployEtcs: false,
        befErtmsDeployGsmr: false,
        aftErtmsDeployGsmr: false,
        remarks: "",
        befPassengerDesignSpeed160: false,
        aftPassengerDesignSpeed160: false,
        befLoadingGauge: false,
        aftLoadingGauge: false,
        befMaxDwellingTimeCrossBorder25: false,
        aftMaxDwellingTimeCrossBorder25: false,
        befStrongInclines: false,
        aftStrongInclines: false
    },
}

export { TODIS_LRAIL_SCHEMA, LRAIL_INIT };